import { Stack, Group, Text, Grid, Center } from '@mantine/core';

import { useNavigate, useParams } from 'react-router-dom';

import { useCallback } from 'react';

import RecentProposalCard from './RecentProposalCard';
import useEnsisQuery from '../../../hooks/useEnsisQuery';

import { NewProposalMenu } from '../../../components/DropdownMenus';
import { CenteredLoader } from '../../../components';

interface Props {
  onClickFastDraft: () => void
}
const MAX_NUM_RECENT_PROPOSALS = 3;

const RecentProposals: React.FC<Props> = (props: Props) => {
  const { onClickFastDraft } = props;
  const { organization } = useParams();
  const { data, isLoading } = useEnsisQuery('/app/proposals/recently-edited-by-me', {
    queryParams: {
      organization_slug: organization ?? '',
      limit: MAX_NUM_RECENT_PROPOSALS
    }
  });
  const navigate = useNavigate();
  const handleClickFullSetup = useCallback(() => {
    navigate(`/org/${organization}/proposals/create-proposal`);
  }, [organization]);
  const recentProposals = data?.items ?? [];

  const emptyState = <Center h='100%'>
    <Text >
      No proposals to display. Click New Proposal to get started.
    </Text>
  </Center>;

  return (
    <Stack gap={20} h='100%'>
      <Group justify="space-between">
        <Text fz={18} fw={500}>
          Pick up where you left off
        </Text>
        <NewProposalMenu
          isLoading={isLoading}
          onClickFastDraft={onClickFastDraft}
          onClickFullSetup={handleClickFullSetup}
        />
      </Group>
      {isLoading
        ? <CenteredLoader h='100%' />
        : recentProposals.length === 0
          ? emptyState
          : (
            <Grid gutter={16}>
              {recentProposals.map((proposal) => (
                <Grid.Col span={4} key={proposal.uid}>
                  <RecentProposalCard proposal={proposal} />
                </Grid.Col>
              ))}
            </Grid>
            )
      }
    </Stack>
  );
};

export default RecentProposals;
